import { format } from 'date-fns';

export function prepareDateToString(locale: Locale|undefined) : (source: (number | Date)) => (f: string) => string{
  return (source: number | Date) => {
    return (f: string) => {
      return format(source,f,{locale: locale});
    };
  };
}

export const prevMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).valueOf();

export const dateToYMDFormat = (date: string | Date) => {
  const dateFormat = 'yyyy-MM-dd';
  if(typeof date === 'string'){
    return format(new Date(date), dateFormat);
  }
  return format(date, dateFormat);
};
